var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "doc-content" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _vm._v("Loading API documentation..."),
        ])
      : _vm.error
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _c("iframe", {
          ref: "scalarIframe",
          staticClass: "scalar-iframe",
          attrs: { src: "/dist/js/vendor/scalar/scalar.html" },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }